var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 28.6913C23.7494 29.055 25.0706 29.25 26.4374 29.25C28.6556 29.25 30.7538 28.7364 32.6196 27.8217C32.6231 27.7358 32.6249 27.6493 32.6249 27.5625C32.6249 24.1452 29.8547 21.375 26.4374 21.375C24.3104 21.375 22.434 22.4483 21.3204 24.0828M22.5 28.6913V28.6875C22.5 27.0182 22.0722 25.4487 21.3204 24.0828M22.5 28.6913C22.5 28.7448 22.4995 28.7982 22.4986 28.8515C19.706 30.5329 16.4347 31.5 12.9375 31.5C9.44029 31.5 6.16896 30.5329 3.37638 28.8515C3.37546 28.7969 3.375 28.7423 3.375 28.6875C3.375 23.4063 7.65628 19.125 12.9375 19.125C16.5494 19.125 19.6935 21.1275 21.3204 24.0828M18 9.5625C18 12.3584 15.7334 14.625 12.9375 14.625C10.1416 14.625 7.875 12.3584 7.875 9.5625C7.875 6.76656 10.1416 4.5 12.9375 4.5C15.7334 4.5 18 6.76656 18 9.5625ZM30.375 12.9375C30.375 15.1121 28.6121 16.875 26.4375 16.875C24.2629 16.875 22.5 15.1121 22.5 12.9375C22.5 10.7629 24.2629 9 26.4375 9C28.6121 9 30.375 10.7629 30.375 12.9375Z",
    stroke: "#101223",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d9a6cb6c96f783ca20e24f219a2a9a65.svg";
export { ForwardRef as ReactComponent };